export default [
	// {
	//   title: 'Dashboards',
	//   icon: 'HomeIcon',

	//   tagVariant: 'light-warning',
	//   children: [
	//     {
	//       title: 'eCommerce',
	//       route: 'dashboard-ecommerce',
	//     },
	//     {
	//       title: 'Analytics',
	//       route: 'dashboard-analytics',
	//     },
	//   ],
	// },
	// {
	// 	title: "Dashboards",
	// 	route: "apps-company-summary",
	// 	icon: "HomeIcon",
	// },
	{
		title: "Dashboard",
		route: "apps-company-summary",
		icon: "HomeIcon",
	},
];
